import type { UseMutationResult } from "@tanstack/react-query"
import { useMutation, useQueryClient } from "@tanstack/react-query"

import { queryKeys } from "~/api/cache"
import type {
  ArcadiaGreenButtonProposalApplicationDto,
  ConfirmArcadiaGreenButtonUsageRequestDto,
} from "~/api/dto/arcadia-green-button.dto"

import { arcadiaGreenButtonService } from "../services/arcadia-green-button.service"

type ConfirmArcadiaGreenButtonUsageParams =
  ConfirmArcadiaGreenButtonUsageRequestDto & {
    proposalId: string
    siteId: string
  }

export const useConfirmArcadiaGreenButtonUsage = (): UseMutationResult<
  ArcadiaGreenButtonProposalApplicationDto,
  unknown,
  ConfirmArcadiaGreenButtonUsageParams,
  unknown
> => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ decision, importId, modeledProfileId, proposalId, siteId }) =>
      arcadiaGreenButtonService.confirmProposalUsage(siteId, proposalId, {
        decision,
        importId,
        modeledProfileId,
      }),
    onSuccess: (_data, { siteId }) => {
      void queryClient.invalidateQueries({
        queryKey: queryKeys.arcadiaGreenButton.site(siteId),
      })
    },
  })
}
